module.exports = __webpack_public_path__ + "static/media/Discovery-Success.d44906f5.svg";